// The office's Navigate in Google Maps (BL-018, maps design place 8): an underlined word, as the
// office's secondary actions are, that opens Google Maps with the drive in a new tab. It sends no
// referrer, so Google learns the address and nothing of the page it came from.
import { NAVIGATE_LABEL, navigateUrl, type NavigatePoint } from '../navigate.ts';

export function NavigateLink(p: { address?: string | null; point?: NavigatePoint | null }) {
  const href = navigateUrl(p);
  if (!href) return null;
  return (
    <a className="flw-link" href={href} target="_blank" rel="noopener noreferrer">
      {NAVIGATE_LABEL}
    </a>
  );
}
